import { useSelector } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import { GET_DEPENDENTS_QUERY_KEY } from './utils';
import { useConfigurationQuery } from 'theSource/queries';
import { DependentsResponseDto } from 'theSource/features/FamilyMembers/types';
import { selectEnrollmentContext } from 'theSource/features/Home/components/EnrollmentBanner/services';

export interface UseEnrollmentFamilyQueryOutput {
  dependentsData?: DependentsResponseDto;
  isLoadingDependents: Boolean;
  isFetchingDependents: Boolean;
}

export interface UseEnrollmentFamilyQueryProps {
  lumosEnabled: boolean;
  manualEnrollmentContextOverride?: string;
}

export const useEnrollmentFamilyQuery = ({
  lumosEnabled,
  manualEnrollmentContextOverride,
}: UseEnrollmentFamilyQueryProps): UseEnrollmentFamilyQueryOutput => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  let enrollmentTypeLookupCode: string | undefined = useSelector(
    selectEnrollmentContext
  );
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (enrollmentTypeLookupCode === 'null' || enrollmentTypeLookupCode === '') {
    enrollmentTypeLookupCode = undefined;
  }

  if (manualEnrollmentContextOverride) {
    enrollmentTypeLookupCode = manualEnrollmentContextOverride;
  }

  const {
    data: dependentsData,
    isLoading: isLoadingDependents,
    isFetching: isFetchingDependents,
  } = useApiQuery<DependentsResponseDto>({
    queryKey: `${GET_DEPENDENTS_QUERY_KEY}-${enrollmentTypeLookupCode}`,
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    endpoint: '/dependents/profile',
    enabled: lumosEnabled && Boolean(isAuthenticated),
    params: { enrollment_type_lookup_code: enrollmentTypeLookupCode },
  });

  return { dependentsData, isLoadingDependents, isFetchingDependents };
};
